// Maps WhatsApp template rule codes (server Smarticks::WhatsappTemplates::Rules and the browser mirror
// whatsappTemplateRules.js) to WA_TEMPLATES.RULES.* i18n keys. No CSS classes here.

export const RULE_KEYS = {
  invalid_name: 'NAME_FORMAT',
  name_too_long: 'NAME_TOO_LONG',
  name_taken: 'NAME_TAKEN',
  invalid_language: 'INVALID_LANGUAGE',
  invalid_category: 'CATEGORY_NOT_ALLOWED',
  body_required: 'BODY_REQUIRED',
  body_too_long: 'BODY_TOO_LONG',
  invalid_body: 'INVALID_BODY',
  invalid_placeholders: 'INVALID_PLACEHOLDERS',
  variables_out_of_order: 'VARIABLES_OUT_OF_ORDER',
  dangling_variable: 'DANGLING_VARIABLE',
  repeated_variable: 'REPEATED_VARIABLE',
  missing_examples: 'MISSING_EXAMPLES',
  example_too_long: 'EXAMPLE_TOO_LONG',
  example_invalid: 'EXAMPLE_INVALID',
  invalid_header: 'INVALID_HEADER',
  header_text_required: 'HEADER_TEXT_REQUIRED',
  header_text_too_long: 'HEADER_TEXT_TOO_LONG',
  header_formatting: 'HEADER_FORMATTING',
  header_too_many_variables: 'HEADER_TOO_MANY_VARIABLES',
  header_example_missing: 'HEADER_EXAMPLE_MISSING',
  header_sample_missing: 'HEADER_SAMPLE_MISSING',
  header_sample_type: 'HEADER_SAMPLE_TYPE',
  header_sample_too_large: 'HEADER_SAMPLE_TOO_LARGE',
  invalid_footer: 'INVALID_FOOTER',
  footer_too_long: 'FOOTER_TOO_LONG',
  footer_variable: 'FOOTER_VARIABLE',
  invalid_buttons: 'INVALID_BUTTONS',
  buttons_too_many: 'BUTTONS_TOO_MANY',
  quick_reply_too_many: 'QUICK_REPLY_TOO_MANY',
  url_too_many: 'URL_TOO_MANY',
  phone_number_too_many: 'PHONE_TOO_MANY',
  copy_code_too_many: 'COPY_CODE_TOO_MANY',
  button_label_required: 'BUTTON_LABEL_REQUIRED',
  button_label_too_long: 'BUTTON_LABEL_TOO_LONG',
  button_label_invalid: 'BUTTON_LABEL_INVALID',
  url_required: 'URL_REQUIRED',
  url_not_https: 'URL_NOT_HTTPS',
  url_too_long: 'URL_TOO_LONG',
  url_not_latin: 'URL_NOT_LATIN',
  url_variable_position: 'URL_VARIABLE_POSITION',
  url_too_many_variables: 'URL_TOO_MANY_VARIABLES',
  url_example_missing: 'URL_EXAMPLE_MISSING',
  url_example_mismatch: 'URL_EXAMPLE_MISMATCH',
  phone_invalid: 'PHONE_INVALID',
  copy_code_marketing_only: 'COPY_CODE_MARKETING_ONLY',
  copy_code_example_missing: 'COPY_CODE_EXAMPLE_MISSING',
  copy_code_too_long: 'COPY_CODE_TOO_LONG',
  copy_code_invalid: 'COPY_CODE_INVALID',
  variable_ratio: 'VARIABLE_RATIO',
  consecutive_spaces: 'CONSECUTIVE_SPACES',
  unauthorized: 'UNAUTHORIZED',
  request_failed: 'NETWORK',
  unsupported_provider: 'UNSUPPORTED_PROVIDER',
};

// t: the vue-i18n translate function. error: [code, detail].
export const ruleMessage = (t, [code, detail] = []) => {
  const key = RULE_KEYS[code];
  if (!key) return code;
  return t(`WA_TEMPLATES.RULES.${key}`, {
    n: detail,
    max: detail,
    found: detail,
    prefix: detail,
  });
};

// A failed API call: our own codes are localised, a free-text 1msg/Meta reason (already capped
// server-side) is passed through.
export const serverErrorMessage = (t, error) => {
  const code = error?.response?.data?.error;
  if (!code) return t('WA_TEMPLATES.RULES.NETWORK');
  if (RULE_KEYS[code]) return ruleMessage(t, [code, error.response.data.detail]);
  return t('WA_TEMPLATES.RULES.SERVER_REJECTED', { reason: code });
};
